import { Injectable, signal } from '@angular/core';

const FIFO_PREVIEW_ENABLED_STORAGE_KEY = 'anessa-fifo-preview-enabled';

/**
 * Owns the on/off toggle for the FIFO preview button on the incorporation
 * saisie pages (see the `~fifopreview` dev command). The feature itself is
 * still restricted to anessa staff (`isAnessaEmail`) — this only controls
 * whether it's shown, off by default, so it doesn't surface unannounced.
 * Persisted to localStorage so the choice survives a reload, same pattern
 * as `TabViewService.enabled`.
 */
@Injectable({ providedIn: 'root' })
export class FifoPreviewSettingsService {
  readonly enabled = signal(this.loadEnabled());

  toggle(): void {
    this.enabled.update((v) => !v);
    this.saveEnabled(this.enabled());
  }

  private loadEnabled(): boolean {
    try {
      return localStorage.getItem(FIFO_PREVIEW_ENABLED_STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  }

  private saveEnabled(value: boolean): void {
    try {
      localStorage.setItem(FIFO_PREVIEW_ENABLED_STORAGE_KEY, String(value));
    } catch {
      // Best-effort — private browsing / storage quota shouldn't break toggling.
    }
  }
}
